import { type ReactNode } from 'react';
import { type MaterialSymbol } from 'material-symbols';

/**
 *
 */
export enum ProjectStatus {
    InProgress = 'in progress',
    OnHold = 'on hold',
    Open = 'open',
    Closed = 'closed',
}

export interface ProjectStatusPresentation {
    icon: MaterialSymbol;
    iconColor: string;
    label: string;
}

const PROJECT_STATUS_PRESENTATIONS: Record<
    ProjectStatus,
    ProjectStatusPresentation
> = {
    [ProjectStatus.Closed]: {
        icon: 'check_circle',
        iconColor: 'var(--guardianGR50)',
        label: 'Closed',
    },
    [ProjectStatus.InProgress]: {
        icon: 'chronic',
        iconColor: 'var(--guardianB50)',
        label: 'In progress',
    },
    [ProjectStatus.OnHold]: {
        icon: 'pause_circle',
        iconColor: 'var(--guardianY70)',
        label: 'On hold',
    },
    [ProjectStatus.Open]: {
        icon: 'nest_secure_alarm',
        iconColor: 'var(--guardianST50)',
        label: 'Open',
    },
};

export function getProjectStatusPresentation(
    status?: string | null,
): ProjectStatusPresentation {
    switch (status) {
        case ProjectStatus.Closed:
            return PROJECT_STATUS_PRESENTATIONS[ProjectStatus.Closed];
        case ProjectStatus.InProgress:
            return PROJECT_STATUS_PRESENTATIONS[ProjectStatus.InProgress];
        case ProjectStatus.OnHold:
            return PROJECT_STATUS_PRESENTATIONS[ProjectStatus.OnHold];
        case ProjectStatus.Open:
        default:
            return PROJECT_STATUS_PRESENTATIONS[ProjectStatus.Open];
    }
}
